module.exports = __webpack_public_path__ + "img/pytorch.c12bc7d4.png";